import React from 'react';
import Slider from 'react-slick';
import { alpha, useTheme } from '@mui/material/styles';
import { Card, Box, CardContent } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const mock = [
	{
		headerSlide: 'FAST behavioral Screening',
		avatar: 'https://slideplayer.com/slide/5710250/18/images/63/behavioral+Assessment+Screening+Tool.jpg',

		subSlideLine1: 'FAST is a well-know indirect behavioral assessment method.',
		subSlideLine2: 'It is comprised of a self-report checklist to identity retained behavior challenges. ',
		subSlideLine3: 'The assessment is a short 16 item checklist of “yes,” “no,” or “not applicable.” responses',
		subSlideLine4: '',
		subSlideLine5: '',

		bodySlideLine1: '',
		bodySlideLine2: '',
		bodySlideLine3: '',
		bodySlideLine4: '',
		bodySlideLine5: '',

		CTA1: 'Schedule Now',
		CTA2: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		LinkforCTA1: '',
		LinkforCTA2: ''
	},

	{
		headerSlide: 'MaaS – Motivational Assessment Screening',
		avatar: 'https://store.monacoassociates.com/images/products/detail/MASEnBundle.jpg',

		subSlideLine1: 'MaaS has been validated across cultures and age groups.',
		subSlideLine2: 'It aids of research-domains related to in self-determination and self-consciousness',
		subSlideLine3:
			'It can be useful in helping people discover a baseline to cultivate this inherent human ability',
		subSlideLine4: '',
		subSlideLine5: '',

		bodySlideLine1: '',
		bodySlideLine2: '',
		bodySlideLine3: '',
		bodySlideLine4: '',
		bodySlideLine5: '',

		CTA1: 'Schedule Now',
		CTA2: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		LinkforCTA1: '',
		LinkforCTA2: ''
	},

	{
		headerSlide: 'QABF Screening',
		avatar: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3jyTZtjJVEJtQY8pJmGD0EgwGPO6Ys1772g4WEYQ2OGyLK-GaAvP9upiaC00a5tGYpvw&usqp=CAU',

		subSlideLine1:
			'QABF Screening helps in functional assessment of behavior problems in persons with developmental disabilities',
		subSlideLine2:
			'The instrument yields five categories reflecting the behavioral functions  - Attention, Escape, Physical, Tangible, and Nonsocial',
		subSlideLine3: '',
		subSlideLine4: '',
		subSlideLine5: '',

		bodySlideLine1: '',
		bodySlideLine2: '',
		bodySlideLine3: '',
		bodySlideLine4: '',
		bodySlideLine5: '',

		CTA1: 'Schedule Now',
		CTA2: '',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: '',

		LinkforCTA1: '',
		LinkforCTA2: ''
	}
];

const FSSFuncBehaviorAssessment = () => {
	const theme = useTheme();

	const sliderOpts = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false
	};

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0
			}}>
			<Box
				position={'relative'}
				zIndex={2}
				paddingX={2}
				paddingTop={{ xs: 0, sm: 0, md: 6, lg: 6 }} // needed to align slides to left-side content
				marginX={{ xs: 'auto', sm: 'auto', md: '0px' }}
				backgroundColor={'none'}
				borderRadius={3}>
				<Box
					maxWidth={{ xs: '75vw', sm: '85vw', md: '68vw', lg: '68vw' }}
					marginX={'auto'}
					paddingX={'auto'}
					marginY={0}
					paddingY={0}>
					<Box
						marginX={'auto'}
						paddingX={'auto'}
						marginY={0}
						paddingY={0}
						sx={{
							height: { xs: 'auto', md: 1 },
							'& .slick-slide img': {
								objectFit: 'cover'
							},
							'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
								height: { xs: 'auto', md: 1 }
							},
							'& .slick-dots': {
								marginTop: { xs: 2, sm: 2, md: 2, lg: 2 },
								top: { xs: '84%', sm: '90%', md: '87%' },
								height: '25px'
							},
							'& .slick-prev': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '0%',
								marginLeft: 0,
								marginRight: '32px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							},
							'& .slick-next': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '100%',
								marginLeft: '62px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							}
						}}>
						<Slider {...sliderOpts}>
							{mock.map((item, i) => (
								<Box key={i}>
									<Card
										sx={{
											display: 'flex',
											flexDirection: {
												xs: 'column',
												md: (i + 1) % 2 === 0 ? 'row' : 'row-reverse'
											},
											boxShadow: 0,
											background: 'transparent'
										}}>
										<CardContent
											sx={{
												display: 'flex',
												alignItems: 'left',
												marginLeft: { sx: 0, md: 2 }
											}}>
											<Box>
												<Box marginBottom={2}>
													<SimTypography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
														{item.headerSlide}
													</SimTypography>

													<SimTypography color={theme.palette.text.secondary}>
														{item.subSlideLine1 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine1}</Box>
														)}
														{item.subSlideLine2 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine2}</Box>
														)}
														{item.subSlideLine3 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine3}</Box>
														)}
														{item.subSlideLine4 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine4}</Box>
														)}
														{item.subSlideLine5 === '' ? (
															<Box>
																{' '}
																<br />{' '}
															</Box>
														) : (
															<Box> {item.subSlideLine5}</Box>
														)}
													</SimTypography>
												</Box>
												<Box
													marginTop={2}
													display={'flex'}
													justifyContent={{ xs: 'center', md: 'flex-start' }}>
													<SimButton
														href={'/resources'}
														endIcon={
															<Box
																component={'svg'}
																xmlns='http://www.w3.org/2000/svg'
																fill='none'
																viewBox='0 0 24 24'
																stroke='currentColor'
																width={24}
																height={24}>
																<path
																	strokeLinecap='round'
																	strokeLinejoin='round'
																	strokeWidth={2}
																	d='M17 8l4 4m0 0l-4 4m4-4H3'
																/>
															</Box>
														}>
														Read More
													</SimButton>
												</Box>
											</Box>
										</CardContent>
									</Card>
								</Box>
							))}
						</Slider>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { FSSFuncBehaviorAssessment };
